import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

function fmtErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

function googleLogin() {
  const redirectUrl = window.location.origin + "/";
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await register(email, password, name); navigate("/", { replace: true }); }
    catch (err) { toast.error(fmtErr(err?.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Create your studio" subtitle="Start generating in seconds">
      <Button onClick={googleLogin} data-testid="google-register-btn"
        className="w-full bg-white text-black hover:bg-zinc-200 font-medium">
        <img alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="h-4 w-4 mr-2" />
        Continue with Google
      </Button>
      <div className="flex items-center gap-3 my-5">
        <div className="h-px flex-1 bg-zinc-800" /><span className="text-[11px] text-zinc-600 font-mono">OR</span><div className="h-px flex-1 bg-zinc-800" />
      </div>
      <form onSubmit={submit} className="space-y-3">
        <Input data-testid="register-name" placeholder="Name (optional)" value={name} onChange={(e) => setName(e.target.value)}
          className="bg-[#121212] border-zinc-800 focus-visible:ring-[#faff69]" />
        <Input data-testid="register-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          className="bg-[#121212] border-zinc-800 focus-visible:ring-[#faff69]" />
        <Input data-testid="register-password" type="password" required placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)}
          className="bg-[#121212] border-zinc-800 focus-visible:ring-[#faff69]" />
        <Button type="submit" disabled={busy} data-testid="register-submit"
          className="w-full bg-[#faff69] text-black hover:bg-[#e6eb52] font-semibold">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <p className="text-sm text-zinc-400 mt-5">Already have an account? <Link to="/login" className="text-[#faff69] hover:underline" data-testid="to-login">Log in</Link></p>
    </AuthShell>
  );
}
